import React, { type ReactElement, useContext, useState } from 'react';

import { usePathname, useRouter } from 'next/navigation';

import classNames from 'classnames';

import { useGetVendorItem } from '@/common/apis/storefronts/v1/get-vendor.api';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button';
import VendorInfoDrawer from '@/common/components/vendor-info-drawer/vendor-info-drawer.component';
import { VendorShareContext } from '@/common/contexts/vendor-share.context';
import { stringFilters } from '@/common/utils/stringFilters.utility';

import ArrowLeftIcon from '~/public/assets/images/svg/arrow.svg';

export interface ExtraDetails {
  telegramAddress: string;
  instagramAddress: string;
  whatsAppAddress: string;
  address: string;
  shopMobilePhone: string;
  shopPhoneNumber: string;
}

interface Props {
  titleClassName?: string;
  btnLinkClassName?: string;
  displayHeading?: boolean;
  isTenant?: boolean;
}

export default function StoreWidget({
  btnLinkClassName,
  titleClassName,
  displayHeading = true,
  isTenant = false,
}: Props): ReactElement {
  const router = useRouter();
  const VendorContext = useContext(VendorShareContext);
  const HeadingTag = VendorContext.isStore ? 'h1' : 'h3';

  const pathName = usePathname();

  const pathSegments = pathName.slice(1).split('/');

  const [openVendorInfoDrawer, setOpenVendorInfoDrawer] =
    useState<boolean>(false);

  const { data } = useGetVendorItem({
    query: { identifier: pathSegments[0] },
    disableToast: true,
    enabled: false,
  });

  const extraDetails: ExtraDetails = {
    telegramAddress: data?.data?.telegramAccount || '',
    instagramAddress: data?.data?.instagramAccount || '',
    whatsAppAddress: data?.data?.whatsAppAccount || '',
    address: data?.data?.vendorAddress?.address || '',
    shopMobilePhone: data?.data?.shopPhoneNumber || '',
    shopPhoneNumber: data?.data?.landLineNumber || '',
  };

  const handleClick = () => {
    setOpenVendorInfoDrawer(true);
  };

  const closwVendorInfoDrawer = () => {
    router.push(`/${pathSegments[0]}`);
    setOpenVendorInfoDrawer(false);
  };
  return (
    <>
      <div className="flex flex-col items-start justify-center gap-[6px] lg:hidden">
        {displayHeading ? (
          <HeadingTag
            className={classNames(
              'text-nowrap text-sm font-semibold text-black-default',
              titleClassName
            )}
          >
            {stringFilters(data?.data.vendorName || '', { removeEmojis: true })}
          </HeadingTag>
        ) : null}
        {data?.data?.vendorName && !isTenant && (
          <AnalyticsWrapper analytics={['store-click-info-v1']}>
            <Button
              type="link"
              className={classNames(
                'flex items-center justify-start gap-x-2 text-xs font-medium lg:hidden',
                btnLinkClassName
              )}
              onClick={handleClick}
              id="store-click-info-v1"
            >
              اطلاعات فروشگاه{' '}
              <ArrowLeftIcon className="h-2 w-[5px] rotate-180" />
            </Button>
          </AnalyticsWrapper>
        )}
      </div>
      <VendorInfoDrawer
        isOpen={openVendorInfoDrawer}
        setOpen={setOpenVendorInfoDrawer}
        logo={data?.data.vendorMedia?.vendorLogo?.url || ''}
        title={data?.data.vendorName || ''}
        description={data?.data.aboutMe || ''}
        action={closwVendorInfoDrawer}
        extraDetails={extraDetails}
      />
    </>
  );
}
